import React, { useState, useContext } from 'react'
import "../styles/componentsStyles/Login.scss"
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import { BASE_URL } from '../api/api';
import { useCookies } from 'react-cookie';

import Eye from "../assets/icons/visibility-on.svg"
import EyeCut from "../assets/icons/visibility-off.svg"

import { Auth } from '../context/Auth';

const Login = () => {

    const [loginDetails, setLoginDetails] = useState({ emailOrUsername: "", password: "" });
    const [showPassword, setShowPassword] = useState(false);
    const [cookies, setCookie] = useCookies(['token', 'userId', 'isLoggedIn', 'channelId']);

    const auth = useContext(Auth);

    const navigate = useNavigate();
    // Toast's 
    const notifyLogin = () => toast("Login Success!");
    const notifyWrongInput = () => toast("❌ Wrong Input");
    const notifyUserNotFound = () => toast("❌ User Not Found");

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    const submitLogin = (e) => {
        e.preventDefault();

        const formData = {
            query: loginDetails.emailOrUsername,
            password: loginDetails.password
        }

        console.log(formData, "formdata");

        axios.post(`${BASE_URL}/api/auth/login`, formData)
            .then(res => {
                console.log(res);
                if (res.data.statusText === "success") {
                    // Perform authentication, and if successful:
                    // const token = 'your_auth_token'; // replace with actual token
                    // const userId = 'user_id'; // replace with actual user ID

                    // Store token, userId, and login status in cookies
                    setCookie('token', res.data.token, { path: '/' });
                    setCookie('userId', res.data.userId, { path: '/' });
                    setCookie('isLoggedIn', true, { path: '/' });
                    fetchUserDetails(res.data.userId);

                    // fetchUserDetails(res.data.userId);
                    // auth.authReducerDispatch({ type: "updateUserId", payload: { userId: res.data.userId } });
                    auth.authReducerDispatch({ type: "updateUserId", payload: { userId: cookies.userId } });
                }
                if (res.data.statusText === "incorrect-password") {
                    notifyWrongInput();
                }
                if (res.data.statusText === "user-not-found") {
                    notifyUserNotFound();
                }
            })
            .catch(err => console.log(err))

        function fetchUserDetails(userID) {
            axios.post(`${BASE_URL}/api/auth/fetch-user-details`, { userId: userID })
                .then(res => {
                    console.log(res, "fecth user success");
                    if (res.data.statusText === "success") {
                        if (res.data.user.channelId) {
                            // setCookie('channelId', res.data.user.channelId, { path: '/' });
                            auth.authReducerDispatch({ type: "updateChannelId", payload: { channelId: res.data.user.channelId } });
                        }
                        notifyLogin();
                        navigate('/');
                    }
                })
                .catch(err => console.log(err))
        }

        // Reset form fields
        setLoginDetails({ ...loginDetails, emailOrUsername: "", password: "" });
    }

    // function fetchUserDetails(userID) {
    //     console.log(userID, "userID");
    //     axios.post(`${BASE_URL}/api/auth/fetch-user-details`, { userId: userID })
    //         .then(res => {
    //             const user = res.data.user
    //             window.sessionStorage.setItem("userDetails", JSON.stringify({ firstName: user.firstName, lastName: user.lastName, username: user.username }))
    //         })
    //         .catch(err => console.log(err))
    // }

    return (
        <div className='login'>
            <div className="login__container">
                <h3 className='login__title'>Login</h3>
                <form action="" onSubmit={submitLogin} className='login__form'>
                    <div className="login__input-group">
                        <label htmlFor="login__username" className='login__label'>Email/Username</label>
                        <input id='login__username' type="text" placeholder='Enter email or username' autoFocus value={loginDetails.emailOrUsername} onChange={(e) => setLoginDetails({ ...loginDetails, emailOrUsername: e.target.value.trim() })} required />
                    </div>

                    <div className="login__input-group">
                        <label htmlFor="login__password" className='login__label'>Password</label>

                        <div className="login__password-container">
                            <input id='login__password' placeholder='Enter Password' type={showPassword ? 'text' : 'password'} value={loginDetails.password} onChange={(e) => setLoginDetails({ ...loginDetails, password: e.target.value })} autoComplete required />
                            <button type="button" onClick={handleTogglePassword}>
                                {showPassword ? <img src={Eye} alt="eye" /> : <img src={EyeCut} alt="eye cut" />}

                            </button>
                        </div>
                    </div>

                    <div className="login__sign-up-link">
                        <p>New user?  <Link to="/sign-up">Sign Up</Link></p>
                    </div>

                    <div className="login__btn-container">
                        <button className='login__button' type='submit'>Log in</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Login